import { newsMarkdownConfig } from "@slfinrtl/news-service-routes"

interface MarkdownNode {
	children?: MarkdownNode[]
	depth?: number
	position?: { end: { offset?: number }; start: { offset?: number } }
	type: string
	value?: string
}

const allowedNodes: ReadonlySet<string> = new Set(newsMarkdownConfig.allowedNodes)
const isSupported = (node: MarkdownNode) =>
	allowedNodes.has(node.type) && (node.type !== "heading" || node.depth === newsMarkdownConfig.allowedHeadingDepth)
// the nodes whose children are blocks, all others have inline children
const blockParents: ReadonlySet<string> = new Set(["root", "listItem", "blockquote"])

/**
 * Turns every markdown element that the news editor does not support into the plain text of its source, e.g. "# hi"
 * stays "# hi" instead of becoming a heading. This is how the editor shows such content as well.
 */
export const remarkSupportedNodesOnly = () => (tree: MarkdownNode, file: { value: unknown }) => {
	const source = String(file.value)

	const toPlainText = (node: MarkdownNode, parent: MarkdownNode): MarkdownNode => {
		const { end, start } = node.position ?? {}
		const text: MarkdownNode = {
			type: "text",
			value:
				start?.offset !== undefined && end?.offset !== undefined ? source.slice(start.offset, end.offset) : "",
		}
		return blockParents.has(parent.type) ? { children: [text], type: "paragraph" } : text
	}

	const convert = (parent: MarkdownNode) => {
		parent.children = parent.children?.map((child) => {
			if (!isSupported(child)) {
				return toPlainText(child, parent)
			}
			convert(child)
			return child
		})
	}

	convert(tree)
}
